/**
 * 校验工具类
 */

/**
 * URL地址
 */
export function validateURL(param) {
  return /^http[s]?:\/\/.*/.test(param);
}
/**
 * 手机号
 */
export function validateMobile(param) {
  return /^1[3456789]\d{9}$/.test(param);
}
/**
 * 电话
 */
export function validatePhone(param) {
  return /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(param);
}
/**
 * 邮箱
 */
export function validateEmail(param) {
  return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(param);
}
/**
 * 身份证
 */
export function validateIDCard(param) {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(param);
}
/**
 * 车牌
 */
export function validateCarPlate(param) {
  return /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/.test(
    param
  );
}
/**
 * 组织机构代码
 */
export function validateOCC(param) {
  return /^[A-Z0-9]{8}-[A-Z0-9]$|^[A-Z0-9]{8}-[A-Z0-9]-[0-9]{2}$/.test(param);
}
